import { useReopenSurveyForRespondentMutation } from 'documents/reopenSurveyForRespondent.generated';
export const useReopenQuestionnaire = () => {
  const [reopenQuestionnaire] = useReopenSurveyForRespondentMutation();

  return { reopenQuestionnaire };
};
